"use client";
import { UseFormReturn } from "react-hook-form";
import { IGiftCardFormFields } from "../types";
import { PersonalMessageComponent } from "./personalMessageComponent";
import { RecipientName } from "./recipientName";
import { RecipientEmail } from "./recipientEmail";
import { useTranslations } from "next-intl";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

interface RecipientInformationComponent {
  form: UseFormReturn<IGiftCardFormFields>;
  isRequired: boolean;
  giftCardSellingEnabled: boolean;
  merchantColor: string;
}

export const RecipientInformationComponent = ({
  form,
  isRequired,
  giftCardSellingEnabled,
  merchantColor,
}: RecipientInformationComponent) => {
  const t = useTranslations("RecipientInformationComponent");
  return (
    <div
      data-testid={applyDataTestId(pom.giftCard.recipientInformationComponent)}
      className="flex flex-col gap-5"
    >
      <p className="text-[#111928] text-[18px] leading-[30px] font-semibold">
        {t("title")}
      </p>
      <div className="flex flex-col md:flex-row gap-5">
        <RecipientName
          label={t("recipientNameLabel")}
          placeholder={t("recipientNamePlaceholder")}
          form={form}
          isRequired={isRequired}
          giftCardSellingEnabled={giftCardSellingEnabled}
          merchantColor={merchantColor}
        />
        <RecipientEmail
          title={t("recipientEmailLabel")}
          placeholder={t("recipientEmailPlaceholder")}
          form={form}
          isRequired={isRequired}
          giftCardSellingEnabled={giftCardSellingEnabled}
          merchantColor={merchantColor}
        />
      </div>
      <PersonalMessageComponent
        title={t("personalMessageLabel")}
        placeholder={t("personalMessagePlaceholder")}
        form={form}
        giftCardSellingEnabled={giftCardSellingEnabled}
        merchantColor={merchantColor}
      />
    </div>
  );
};
